/*
 * @Descripttion:
 * @version:
 * @Author:
 * @Date: 2020-02-10 14:39:02
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-02-14 16:41:52
 */
import angular from 'angular'
import taxClassPage from './view/taxClassList.html'

class taxClassListCtrl {
  constructor(httpRequest, dictService, sweetalert) {
    const scope = this
    // 缓存字典枚举
    dictService.get('is_sum')
    dictService.get('is_hide')
    scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        taxName: '',
        taxCode: '',
        accessToken: localStorage.getItem('id_token'),
      },
    }
    scope.reset = function () {
      scope.queryParam.param = {
        taxName: '',
        taxCode: '',
        accessToken: localStorage.getItem('id_token'),
      }
    }
    // scope.reset()
    function queryTaxClassList() {
      httpRequest.post_getSysTaxClassList(scope.queryParam).then((res) => {
        scope.listData = res.data.value.list
        // 获取后台分页数据 回写分页组件
        scope.totalItems = res.data.value.total
        scope.queryParam.pageNum = res.data.value.pageNum
      })
    }
    scope.queryTaxClassList = queryTaxClassList
    queryTaxClassList()
    // 导入配置
    scope.importconfig = {
      code: 'TAX_CLASS',
      validate: {
        pattern: '.xml',
        _validate: {
          size: { min: 10, max: '10MB' },
          duration: { min: '1s', max: '5m' },
          accept: 'text/xml',
        },
      },
      callback() {
        queryTaxClassList()
      },
      appName: host.etcloudOvat,
      url: 'dlTaskService/import_TAX_CLASS',
    }
    // 表头排序
    scope.orderMap = { sortKey: '', sortVal: '' }
    scope.selectedHandle = function selectedHandle() {
      scope.queryParam.orderMap = {}
      if (scope.orderMap.sortKey)
        scope.queryParam.orderMap[scope.orderMap.sortKey] =
          scope.orderMap.sortVal
      scope.queryTaxClassList()
    }
    // 导入确认弹窗
    scope.upload = function () {
      const resData = scope.listData
      console.log(resData)
      if (resData.length > 0) {
        const { codeVersions } = resData[0]
        // 弹出确认框
        const msg = `您当前使用的版本是${codeVersions}，请确保导入的版本号高于当前版本`
        sweetalert.confirm('确认上传', msg).then(
          () => {
            angular.element('#J_uploadFiles .j-importexcel').click()
          },
          () => {}
        )
      } else {
        // 导入按钮触发
        angular.element('#J_uploadFiles .j-importexcel').click()
      }
    }
    // 导出
    scope.exportTaxClass = function exportTaxClass() {
      httpRequest.get_exportTaxClassToExcel(scope.queryParam.param)
    }
    //
    scope.callbackBusinessSystem = function () {
      let params = {
        accessToken: localStorage.getItem('id_token'),
      }
      // loading动画
      const loadinglayer = layer.msg('回调中，请耐心等待', {
        time: 0,
        skin: 'layer-loading-self',
        icon: 16,
        shade: 0.5,
      })
      httpRequest.post_taxClassToBusinessSystem(params).then((res) => {
        if (res.status == 200) {
          layer.close(loadinglayer)
        } else {
          layer.close(loadinglayer)
        }
      })
    }
  }
}
taxClassListCtrl.$inject = ['httpRequest', 'dictService', 'sweetalert']
export default angular
  .module('system.basedata.taxPolicy.taxClass', [])
  .controller('taxClassCtrl', taxClassListCtrl)
  .component('taxClass', {
    controller: 'taxClassCtrl',
    template: taxClassPage,
  }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/taxClassListComponent.js